import script from "./Donative.vue?vue&type=script&setup=true&lang=js"
export * from "./Donative.vue?vue&type=script&setup=true&lang=js"

import "./Donative.vue?vue&type=style&index=0&id=bcdcda6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcdcda6c"]])

export default __exports__